import { useEffect } from 'react';

// Mobilde tablolar kart görünümüne geçer: her hücreye başlığını data-label olarak yazar (CSS: index.css .mobile-cards)
const label = (table) => {
  const headRow = table.tHead?.rows[table.tHead.rows.length - 1];
  if (!headRow || table.classList.contains('no-mobile-cards')) return;
  const heads = [];
  for (const th of headRow.cells) for (let i = 0; i < (th.colSpan || 1); i++) heads.push(th.textContent.trim());
  table.classList.add('mobile-cards');
  for (const body of table.tBodies) {
    for (const tr of body.rows) {
      let idx = 0;
      for (const td of tr.cells) {
        const text = td.colSpan > 1 ? '' : heads[idx] || '';
        if (td.getAttribute('data-label') !== text) td.setAttribute('data-label', text);
        idx += td.colSpan || 1;
      }
    }
  }
};

export const MobileTableLabels = () => {
  useEffect(() => {
    let raf = 0;
    const run = () => { raf = 0; document.querySelectorAll('table').forEach(label); };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(run); };
    const obs = new MutationObserver(schedule);
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    schedule();
    return () => { obs.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, []);
  return null;
};
